import React from "react";
import {
  Box,
  Text,
  Divider,
  VStack,
  Badge,
  Flex,
} from "@chakra-ui/react";
import NoDataFound from "components/NoDataGraphics/NoDataFound";
import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import { EllipsisVertical } from "lucide-react";

const ReportList = ({
  reports,
  renderReportDetails,
  renderMenuItems,
  noDataMessage
}) => {
  return (
    <Box p={4}>

      {/* Check if there are any reports */}
      {reports && reports.length > 0 ? (
        <VStack spacing={4} align="stretch">
          {reports.map((report, index) => (
            <Box
              key={index}
              borderWidth="1px"
              borderRadius="md"
              p={4}
              bg="gray.50"
              position="relative"
            >
              {/* Header with three-dot menu for status change */}
              <Flex justify="space-between" align="center">
                <Text fontWeight="500" mb={2} color="gray.500" fontSize="sm">
                  Report #{index + 1}
                </Text>

                {/* Three-dot menu */}
                <ThreeDotMenu
                  icon={<EllipsisVertical />} // Pass the icon here
                  items={renderMenuItems(report)} // Dynamic menu items based on the report
                />
              </Flex>

              {/* Report details */}
              {renderReportDetails(report)}

              {/* Status Badge
              <Flex align="center" gap={2} mt={2}>
                <Text fontSize="sm" color="gray.500" fontWeight={"bold"}>
                  Status:
                </Text>
                <Badge
                  colorScheme={
                    report.status === "Resolved"
                      ? "green"
                      : report.status === "In Progress"
                        ? "blue"
                        : "orange"
                  }
                >
                  {report.status}
                </Badge>
              </Flex> */}

            </Box>
          ))}
        </VStack>
      ) : (
        <NoDataFound
          message={noDataMessage || "No reports found"}
          width="100px"
          height="100px"
          fontSize="md"
          fontWeight="500"
          textColor="gray.400"
        />
      )}
    </Box>
  );
};

export default ReportList;
